import styled from 'styled-components';

interface EditableContainerProps {
  index: number;
  runningTutorial?: boolean;
}

export const EditableBlockContainer = styled.div<EditableContainerProps>`
  display: flex;
  flex: 0 1;
  gap: 6px;
  position: relative;
  align-items: center;
  font: 400 1rem/1.5rem 'Roboto', sans-serif;
  z-index: ${({ index }: {index: any}) => 1000 - index};

  > button {
    ${({ runningTutorial }: {runningTutorial: any}) =>
      runningTutorial &&
      `
      visibility: visible;
      opacity: 0.6;
      `}
  }

  &:focus-within,
  &:hover {
    p {
      background: ${({ theme }: {theme: any}) => theme.white};
    }

    > button {
      visibility: visible;
      opacity: 0.6;

      &:hover {
        opacity: 1;
      }
    }
  }

  p {
    position: relative;
    padding: 4px 16px;
    flex: 1;
    border-radius: 6px;
    max-width: 100%;
    transition: all 0.3s ease;
    word-break: break-all;
    user-select: none;

    ${({ runningTutorial, theme }: {runningTutorial: any, theme: any}) =>
      runningTutorial &&
      `
      background: ${theme.white};
      `}

    &:focus {
      background: ${({ theme }: {theme: any}) => theme.white};
    }

    span.selection {
      background-color: ${({ theme }: {theme: any}) => theme.themeLighter};
    }
  }
`;

export const BlockEffectsContainer = styled.div`
  display: flex;
  gap: 3px;
  height: 1.2rem;
  align-items: center;

  > svg {
    color: ${({ theme }: {theme: any}) => theme.themePrimary};
  }
`;

export const BlockActionButton = styled.button`
  width: 1.5rem;
  height: 1.5rem;

  visibility: hidden;
  opacity: 0;

  display: flex;
  background: transparent;
  border: none;
  cursor: pointer;

  transition: all 0.3s ease;

  svg {
    color: ${({ theme }: {theme: any}) => theme.themePrimary};
  }
`;

export const VoiceLabel = styled.span`
  padding: 0.1rem 0.5rem;
  margin-right: 1rem;
  border-radius: 1rem;
  font: 700 0.7rem/0.9rem 'Roboto', sans-serif;
  border: 1px solid ${({ theme }: {theme: any}) => theme.themePrimary};
  color: ${({ theme }: {theme: any}) => theme.themePrimary};
  background: transparent;
  opacity: 0.5;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
`;

export const SelectionMarkers = styled.div`
  .selection {
    background: ${({ theme }: {theme: any}) => theme.themeTertiary};
    border-radius: 4px;
    opacity: 0.4;
    cursor: pointer;

    &:hover {
      opacity: 0.5;
    }
  }
`;

interface SentenceTooltipProps {
  isVisible: boolean;
  rightDistance?: number;
}

export const SentenceTooltip = styled.span<SentenceTooltipProps>`
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  background: ${({ theme }: {theme: any}) => theme.neutralQuaternary};
  color: ${({ theme }: {theme: any}) => theme.black};
  position: absolute;
  left: 60px;
  top: calc(100% + 8px);
  border-radius: 6px;
  padding: 0.3rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  transition: all 0.3s ease;
`;
